import React, { Component, Suspense, Fragment, useState, useEffect } from "react";
import { Route } from "react-router-dom";
import { Link } from 'react-router-dom';
import Loading from "../../components/loading";
import "./home.css";

const Home = (props) => {
  const [showStatus, setShowStatus] = useState(false)
  
  useEffect(() => {

    window?.location?.href?.split('/').pop() == "place-your-order" ? setShowStatus(true) : (window.location.pathname == "/place-your-order") ? setShowStatus(true) : setShowStatus(false)
  });
  
     return (
      <div className="homeWrapper">
        <div className="homeContainer">
          <Fragment>
          <div className={`homeCol2 bannerPort ${showStatus && 'd-none'}`}>
              <div className="contentBodyBlock box475">
                {/* <h1 className="headingLine whiteTx">Atoms in the service of nation</h1>  */}
                {/* <h2 className="puhchLine">The Conference Platforms with an <br /> Unparalleled User Experience</h2> */}
              </div>
            </div>
            <div className="homeCol2 brdrWLeft overflowFlexBox">
            <Suspense fallback={<Loading />}>
              <Route exact path={props.path} {...props} component={props.component} />
            </Suspense>
          </div>
          </Fragment>
      
        </div>
      </div >
     )
  }
export default Home;